<div class="ticker" [attr.aria-label]="label">
  <div class="ticker-label">
    <span class="ticker-dot" aria-hidden="true"></span>
    {{ label }}
  </div>
  <div class="ticker-track">
    <div class="ticker-marquee">
      <ng-container *ngFor="let entry of doubledEntries; let i = index; let last = last">
        <a class="tick"
           role="link"
           tabindex="0"
           (click)="onTickClick(entry)"
           (keydown.enter)="onTickClick(entry)">
          <pla-plate [rawPlate]="entry.plate"
                     [showPrice]="false"
                     [customClass]="'flat shaded'"
                     [xSmallPlate]="true"
                     [openModal]="false"
                     [clickThrough]="false"
                     [noMargin]="true"></pla-plate>
          <span class="tick-sold" data-verb="sold">{{ formatPrice(entry.price) }}</span>
        </a>
        <span class="tick-sep" *ngIf="!last">&middot;</span>
      </ng-container>
    </div>
  </div>
</div>
